(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["killer-garment-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kp-garment-gallery'))customElements.define('kp-garment-gallery',class extends HTMLElement{
connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.events=new AbortController();const signal=this.events.signal;
  const main=this.querySelector('.kpg-main');
  const photos=Array.from(main.querySelectorAll('[data-photo-id]'));
  const counter=this.querySelector('[data-photo-counter]');
  const dialog=this.querySelector('[data-zoom-dialog]');
  const opener=this.querySelector('[data-zoom-open]');
  const stage=dialog?.querySelector('[data-zoom-stage]');
  const canvas=dialog?.querySelector('[data-zoom-canvas]');
  const zoomImage=dialog?.querySelector('[data-zoom-image]');
  const zoomCounter=dialog?.querySelector('[data-zoom-counter]');
  const toggle=dialog?.querySelector('[data-zoom-toggle]');
  const status=dialog?.querySelector('[data-zoom-status]');
  let zoomed=false,zoomFactor=1,dimensions={width:1,height:1},drag=null,suppressClick=false,scrollLock=null,returnFocus=null;
  const selectedIndex=()=>Math.max(0,photos.findIndex(photo=>!photo.hidden));
  const layout=center=>{
    if(!dialog?.open||!stage.clientWidth||!stage.clientHeight)return;
    const cx=(stage.scrollLeft+stage.clientWidth/2)/Math.max(1,stage.scrollWidth);
    const cy=(stage.scrollTop+stage.clientHeight/2)/Math.max(1,stage.scrollHeight);
    const fit=Math.min(stage.clientWidth/dimensions.width,stage.clientHeight/dimensions.height);
    const width=Math.max(1,Math.floor(dimensions.width*fit*zoomFactor));
    const height=Math.max(1,Math.floor(dimensions.height*fit*zoomFactor));
    zoomImage.style.width=width+'px';zoomImage.style.height=height+'px';
    canvas.style.width=Math.max(stage.clientWidth,width)+'px';canvas.style.height=Math.max(stage.clientHeight,height)+'px';
    stage.scrollLeft=(center?0.5:cx)*stage.scrollWidth-stage.clientWidth/2;
    stage.scrollTop=(center?0.5:cy)*stage.scrollHeight-stage.clientHeight/2;
  };
  const setScale=value=>{
    zoomFactor=typeof value==='number'?Math.max(1,Math.min(4,value)):(value?2:1);zoomed=zoomFactor>1.01;dialog.toggleAttribute('data-magnified',zoomed);
    toggle.setAttribute('aria-pressed',String(zoomed));zoomImage.setAttribute('aria-label',zoomed?dialog.dataset.zoomOutLabel:dialog.dataset.zoomInLabel);
    toggle.setAttribute('aria-label',zoomed?dialog.dataset.zoomOutLabel:dialog.dataset.zoomInLabel);
    toggle.querySelector('[data-zoom-symbol]').textContent=zoomed?'−':'+';
    toggle.querySelector('[data-zoom-scale]').textContent=zoomed?dialog.dataset.fitLabel:'2×';
    layout(true);
  };
  const renderZoom=()=>{
    if(!dialog?.open||!photos.length)return;
    const index=selectedIndex(),photo=photos[index];
    dimensions={width:Number(photo.dataset.imageWidth)||1,height:Number(photo.dataset.imageHeight)||1};
    zoomImage.width=dimensions.width;zoomImage.height=dimensions.height;
    zoomImage.alt=photo.querySelector('img')?.alt||'';
    zoomImage.hidden=true;status.hidden=false;status.textContent=dialog.dataset.loadingLabel;
    stage.setAttribute('aria-busy','true');zoomCounter.textContent=(index+1)+' / '+photos.length;
    setScale(false);
    if(zoomImage.getAttribute('src')!==photo.dataset.zoomSrc||zoomImage.complete&&!zoomImage.naturalWidth)zoomImage.src=photo.dataset.zoomSrc;
    if(zoomImage.complete&&zoomImage.naturalWidth){zoomImage.hidden=false;status.hidden=true;stage.setAttribute('aria-busy','false');}
  };
  this.show=id=>{
    const index=photos.findIndex(photo=>photo.dataset.photoId===id);
    if(index<0)return;
    photos.forEach((photo,i)=>photo.hidden=i!==index);
    this.querySelectorAll('[data-show-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.showPhoto===id)));
    if(counter)counter.textContent=(index+1)+' / '+photos.length;
    if(dialog?.open)renderZoom();
  };
  const step=direction=>{if(photos.length)this.show(photos[(selectedIndex()+direction+photos.length)%photos.length].dataset.photoId)};
  const restore=()=>{
    drag=null;dialog?.removeAttribute('data-dragging');
    if(!scrollLock)return;
    const saved=scrollLock;scrollLock=null;
    for(const [property,value,priority] of saved.styles){if(value)document.body.style.setProperty(property,value,priority);else document.body.style.removeProperty(property)}
    window.scrollTo({left:saved.x,top:saved.y,behavior:'instant'});
    if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});
    returnFocus=null;
  };
  this.cleanupZoom=()=>{if(dialog?.open)dialog.close();restore()};
  const openZoom=()=>{
    if(!dialog||dialog.open)return;
    returnFocus=document.activeElement;const body=document.body;
    scrollLock={x:window.scrollX,y:window.scrollY,styles:['overflow','position','top','left','right','width'].map(property=>[property,body.style.getPropertyValue(property),body.style.getPropertyPriority(property)])};
    dialog.showModal();
    body.style.overflow='hidden';body.style.position='fixed';body.style.top=-scrollLock.y+'px';body.style.left=-scrollLock.x+'px';body.style.right='0';body.style.width='100%';
    renderZoom();dialog.querySelector('[data-zoom-close]').focus({preventScroll:true});
  };
  this.addEventListener('click',event=>{
    if(dialog?.contains(event.target)){
      if(suppressClick){suppressClick=false;return}
      if(event.target.closest('[data-zoom-close]'))dialog.close();
      else if(event.target.closest('[data-zoom-toggle]')||event.target===zoomImage)setScale(!zoomed);
      else if(event.target.closest('[data-zoom-step]'))step(Number(event.target.closest('[data-zoom-step]').dataset.zoomStep));
      else if(event.target===dialog||(!zoomed&&(event.target===stage||event.target===canvas)))dialog.close();
      return;
    }
    if(event.target.closest('[data-zoom-open]')||event.target.closest('[data-photo-id]')){if(suppressClick){suppressClick=false;return}openZoom();return}
    const thumbnail=event.target.closest('[data-show-photo]');if(thumbnail)this.show(thumbnail.dataset.showPhoto);
    const control=event.target.closest('[data-photo-step]');if(control)step(Number(control.dataset.photoStep));
  },{signal});
  this.addEventListener('keydown',event=>{
    if(dialog?.open&&event.target===zoomImage&&(event.key==='Enter'||event.key===' ')){event.preventDefault();setScale(!zoomed);return}
    if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;
    if(dialog?.open&&zoomed&&event.target===stage)return;
    if(photos.length>1){event.preventDefault();step(event.key==='ArrowLeft'?-1:1)}
  },{signal});
  if(this.hasAttribute('data-slideshow')){
    let start=null;
    main.addEventListener('touchstart',event=>{start=event.touches.length===1&&!event.target.closest('button')?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null},{passive:true,signal});
    main.addEventListener('touchend',event=>{
      if(!start)return;const end=event.changedTouches[0];const dx=end.clientX-start.x,dy=end.clientY-start.y;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){suppressClick=true;step(dx<0?1:-1)}start=null;
    },{passive:true,signal});
    main.addEventListener('touchcancel',()=>{start=null},{passive:true,signal});
  }
  if(dialog&&typeof dialog.showModal==='function'){
    opener.hidden=false;
    dialog.addEventListener('close',restore,{signal});
    dialog.addEventListener('pointerdown',()=>{suppressClick=false},{signal});
    zoomImage.addEventListener('load',()=>{zoomImage.hidden=false;status.hidden=true;stage.setAttribute('aria-busy','false');layout(false)},{signal});
    zoomImage.addEventListener('error',()=>{zoomImage.hidden=true;status.hidden=false;status.textContent=dialog.dataset.errorLabel;stage.setAttribute('aria-busy','false')},{signal});
    const pointers=new Map();let pinch=null;
    stage.addEventListener('pointerdown',event=>{
      if(event.button!==0)return;
      pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});stage.setPointerCapture(event.pointerId);
      if(pointers.size===2){const [a,b]=Array.from(pointers.values());pinch={distance:Math.hypot(a.x-b.x,a.y-b.y),scale:zoomFactor};drag=null;suppressClick=true;return}
      drag={x:event.clientX,y:event.clientY,left:stage.scrollLeft,top:stage.scrollTop,moved:false,pointerType:event.pointerType};
    },{signal});
    stage.addEventListener('pointermove',event=>{
      if(!pointers.has(event.pointerId))return;pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(pinch&&pointers.size===2){const [a,b]=Array.from(pointers.values());setScale(pinch.scale*Math.hypot(a.x-b.x,a.y-b.y)/Math.max(1,pinch.distance));suppressClick=true;return}
      if(!drag)return;const dx=event.clientX-drag.x,dy=event.clientY-drag.y;drag.moved=drag.moved||Math.abs(dx)+Math.abs(dy)>6;
      if(zoomed){stage.scrollLeft=drag.left-dx;stage.scrollTop=drag.top-dy;if(drag.moved)dialog.setAttribute('data-dragging','')}
    },{signal});
    const endDrag=event=>{
      pointers.delete(event.pointerId);
      if(pinch){if(!pointers.size)pinch=null;drag=null;suppressClick=true;return}
      if(drag){const dx=event.clientX-drag.x,dy=event.clientY-drag.y;suppressClick=drag.moved;if(event.type==='pointerup'&&!zoomed&&Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5)step(dx<0?1:-1)}
      if(drag&&!drag.moved&&event.type==='pointerup'){setScale(!zoomed);suppressClick=true}
      drag=null;dialog.removeAttribute('data-dragging');
    };
    stage.addEventListener('pointerup',endDrag,{signal});stage.addEventListener('pointercancel',endDrag,{signal});
    this.zoomResize=new ResizeObserver(()=>layout(false));this.zoomResize.observe(stage);
  }
  const variants=JSON.parse(this.querySelector('[data-variant-photos]').textContent).variants;
  this.closest('section')?.addEventListener('change',event=>{if(event.target.matches('[name="id"],[data-kp-zakeke-variant]'))this.show(variants.find(variant=>variant.id===event.target.value)?.imageId)},{signal});
  const selected=photos.find(photo=>!photo.hidden);if(selected)this.show(selected.dataset.photoId);
  this.addEventListener('error',event=>{if(event.target.tagName==='IMG'&&event.target!==zoomImage)event.target.hidden=true},{capture:true,signal});
}
disconnectedCallback(){this.cleanupZoom?.();this.events?.abort();this.zoomResize?.disconnect();this.ready=false}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["killer-home-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kp-home-slideshow')) {
customElements.define('kp-home-slideshow', class extends HTMLElement {
connectedCallback() {
this.controller = new AbortController();
const signal = this.controller.signal;
this.track = this.querySelector('.kp-home-slideshow__track');
const openingSlide = this.track.querySelector('img[alt="Colorful guitarist artwork being printed on a Brother GTXpro"]')?.closest('.kp-home-slideshow__slide'); const thirdSlide = this.track.querySelector('[data-original-slide="23"]'); if (openingSlide) { this.track.prepend(openingSlide); openingSlide.querySelector('img').loading = 'eager'; } if (thirdSlide) { thirdSlide.remove(); this.track.insertBefore(thirdSlide, this.track.children[2] || null); } const tintSlide = this.track.querySelector('[data-tint-shack]'); if (tintSlide) { tintSlide.remove(); this.track.insertBefore(tintSlide, this.track.children[4] || null); } const taosSlide=this.track.querySelector('[data-taos-roots]');if(taosSlide){taosSlide.remove();this.track.insertBefore(taosSlide,this.track.children[14]||null);}const patchSlide=this.track.querySelector('[data-patch-detail]');if(patchSlide){patchSlide.remove();this.track.insertBefore(patchSlide,this.track.children[15]||null);}const shopDisplay=this.track.querySelector('[data-shop-photo="display"]');if(shopDisplay){shopDisplay.remove();this.track.insertBefore(shopDisplay,this.track.children[10]||null);}const shopRack=this.track.querySelector('[data-shop-photo="rack"]');if(shopRack){shopRack.remove();this.track.insertBefore(shopRack,this.track.children[24]||null);}/* Swap requested slideshow pairs after the base ordering. */
[[5,17],[4,9],[7,12]].forEach(([a,b])=>{const first=this.track.children[a-1],second=this.track.children[b-1];if(first&&second){const marker=document.createComment('slide position');first.replaceWith(marker);second.replaceWith(first);marker.replaceWith(second);}});
this.slides = [...this.querySelectorAll('.kp-home-slideshow__slide')]; this.slides.forEach((slide, i) => slide.setAttribute('aria-label', (i + 1) + ' / ' + this.slides.length));
this.count = this.querySelector('.kp-home-slideshow__count');
this.toggle = this.querySelector('[data-toggle]');
this.index = 0;
this.motion = matchMedia('(prefers-reduced-motion: reduce)');
this.paused = this.motion.matches;
this.visible = false;
this.started = false;
this.querySelector('.kp-home-slideshow__controls').hidden = false;
this.update = () => {
this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
const label = this.paused ? this.dataset.play : this.dataset.pause;
if (this.shownIndex === this.index && this.shownLabel === label) return;
this.shownIndex = this.index; this.shownLabel = label;
this.count.textContent = (this.index + 1) + ' / ' + this.slides.length;
this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
this.toggle.textContent = label;
};
this.schedule = () => {
clearTimeout(this.timer);
if (!this.paused && this.visible && !document.hidden) this.timer = setTimeout(() => this.go(this.index + 1), this.index === 0 ? 7000 : 4000);
};
this.go = (index) => {
const next = (index + this.slides.length) % this.slides.length;
this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
this.schedule();
};
this.resetToFirst = () => {
clearTimeout(this.timer);
this.index = 0;
this.track.scrollTo({ left: 0, behavior: 'instant' });
this.update();
this.schedule();
};
window.addEventListener('pageshow', () => { this.started = false; this.resetToFirst(); }, { signal });
this.querySelector('[data-previous]').addEventListener('click', () => this.go(this.index - 1), { signal });
this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), { signal });
this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.update(); this.schedule(); }, { signal });
this.track.addEventListener('keydown', e => {
if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1)); }
}, { signal });
this.track.addEventListener('scroll', () => { this.update(); this.schedule(); }, { passive: true, signal });
document.addEventListener('visibilitychange', this.schedule, { signal });
this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.update(); this.schedule(); }, { signal });
this.observer = new IntersectionObserver(entries => {
this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
if (this.visible && !this.started) { this.started = true; this.resetToFirst(); }
else this.schedule();
}, { threshold: [0, .25] });
this.observer.observe(this);
this.resize = new ResizeObserver(() => this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }));
this.resize.observe(this.track);
this.resetToFirst();
}
disconnectedCallback() {
clearTimeout(this.timer); this.controller.abort(); this.observer.disconnect(); this.resize.disconnect();
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["killer-logo-chain"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kp-logo-chain'))customElements.define('kp-logo-chain',class extends HTMLElement{
 connectedCallback(){
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.live=this.querySelector('.kp-chain-live');this.animations=[];this.timers=[];
  this.cancel=()=>{this.button?.classList.remove('kp-order-struck');this.timers.forEach(clearTimeout);this.timers=[];this.animations.forEach(a=>a.cancel());this.animations=[];this.live.replaceChildren();};
  this.run=()=>{
   this.cancel();if(this.motion.matches||document.hidden)return;
   const img=document.querySelector('.kp-wood-banner__image'),frame=img?.parentElement,button=[...document.querySelectorAll('.kr-header .kr-tools .kr-order, .kr-mobile-order')].find(el=>el.getBoundingClientRect().width>0);if(!img||!button||img.closest('kp-wood-banner')?.dataset.effectsVisible !== 'true'||Number(getComputedStyle(frame).opacity)<.5)return;
   this.button=button;const rect=img.getBoundingClientRect(),target=button.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight||!target.width||target.bottom<0)return;
   const scale=Math.min(rect.width/1952,rect.height/1275),ox=rect.left+(rect.width-1952*scale)/2,oy=rect.top+(rect.height-1275*scale)/2;
   const map=p=>({x:ox+p.x*scale,y:oy+p.y*scale});
   const draw=(points,delay,duration,orderStrike=false)=>{
    const p=document.createElementNS('http://www.w3.org/2000/svg','path');p.setAttribute('d',points.map((pt,i)=>`${i?'L':'M'}${pt.x.toFixed(1)},${pt.y.toFixed(1)}`).join(' '));if(orderStrike)p.classList.add('kp-order-lightning');p.style.opacity='0';this.live.append(p);
    const length=p.getTotalLength();p.style.strokeDasharray=String(length);p.style.strokeDashoffset=String(length);
    this.timers.push(setTimeout(()=>{const a=p.animate([{opacity:0,strokeDashoffset:length},{opacity:.85,strokeDashoffset:length,offset:.05},{opacity:.85,strokeDashoffset:0,offset:.75},{opacity:0,strokeDashoffset:0}],{duration,easing:'ease-out'});this.animations.push(a);},delay));
   };
   [...this.querySelectorAll('.kp-lightning-guides path')].forEach((guide,index)=>{const length=guide.getTotalLength();let points=Array.from({length:65},(_,i)=>{const p=guide.getPointAtLength(length*i/64);return map({x:p.x,y:p.y+(i%2?1:-1)*Math.random()*5});});if(index<2)points.reverse();draw(points,130+index*45,430);});
   const start=map({x:1750,y:430}),end={x:target.left+target.width/2,y:target.top>start.y?target.top:target.bottom};
   const travel=Array.from({length:18},(_,i)=>{const t=i/17,jitter=i&&i<17?(Math.random()-.5)*20:0;return{x:start.x+(end.x-start.x)*t+jitter,y:start.y+(end.y-start.y)*t};});draw(travel,560,280,true);
   [[790,true],[3080,false],[3180,true],[3290,false]].forEach(([delay,on])=>this.timers.push(setTimeout(()=>button.classList.toggle('kp-order-struck',on),delay)));
   this.timers.push(setTimeout(()=>this.cancel(),3290));
  };
  document.addEventListener('killer:logo-hidden',this.cancel);document.addEventListener('killer:logo-strike',this.run);document.addEventListener('visibilitychange',this.cancel);this.motion.addEventListener('change',this.cancel);addEventListener('scroll',this.cancel,{passive:true});addEventListener('resize',this.cancel);
 }
 disconnectedCallback(){this.cancel();document.removeEventListener('killer:logo-hidden',this.cancel);document.removeEventListener('killer:logo-strike',this.run);document.removeEventListener('visibilitychange',this.cancel);this.motion.removeEventListener('change',this.cancel);removeEventListener('scroll',this.cancel);removeEventListener('resize',this.cancel);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["killer-product-services"] && !Shopify.designMode) return;
  try {
    window.KillerPrint = window.KillerPrint || {};
window.KillerPrint.catalog = {
 available(variant) { return Boolean(variant.available) && variant.stockStatus !== 'out_of_stock'; },
 compatible(product, method) { return !method || product.methods.map(x => x.toLowerCase()).includes(method.toLowerCase()); },
 find(products, filters, recommend) {
  return products.filter(p => Object.entries(filters).every(([key, value]) => !value || (key === 'method' ? this.compatible(p, value) : p[key] === value))).sort((a,b) => recommend ? Number(b.recommended)-Number(a.recommended) || Number(a.rank)-Number(b.rank) || a.title.localeCompare(b.title) : a.title.localeCompare(b.title));
 },
 handoff(product, variant, method) {
  if (!product || !variant || !product.variants.some(v => v.id === variant.id) || !this.available(variant)) throw new Error('invalid-selection');
  if (method && !this.compatible(product, method)) throw new Error('unsupported-method');
  return {zakekeEnabled:product.zakekeEnabled===true,version:1,productId:product.id,productGid:product.gid,variantId:variant.id,variantGid:variant.gid,productName:product.title,brand:product.brand,styleId:product.styleId,color:variant.color,garmentType:product.type,garmentStyle:product.style,qualityTier:product.quality,garmentFamily:product.family,compatibility:{dtg:product.dtgScore,dtf:product.dtfScore,methods:product.methods},printMethod:method || null};
 }
};
window.KillerPrint.customization = {
 launch(root, handoff) {
  if(handoff.zakekeEnabled && window.KillerPrint.launchZakekeCustomizer){const result=window.KillerPrint.launchZakekeCustomizer(handoff);if(result.launched)return true;}
  const event = new CustomEvent('killer:customize', {bubbles:true,cancelable:true,detail:JSON.parse(JSON.stringify(handoff))});
  return !root.dispatchEvent(event);
 }
};
window.dispatchEvent(new Event('killer:services-ready'));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["killer-work-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kp-work-gallery'))customElements.define('kp-work-gallery',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.photos=Array.from(this.querySelectorAll('[data-work-photo]'));this.viewer=this.querySelector('dialog');this.full=this.querySelector('.kw-full');this.index=0;this.limit=4;this.album=this.querySelector('.kw-album');this.albumButton=this.querySelector('[data-open-album]');this.refresh();this.albumButton.addEventListener('click',()=>this.album.showModal());this.querySelector('[data-close-album]').addEventListener('click',()=>this.album.close());this.album.addEventListener('close',()=>this.albumButton.focus({preventScroll:true}));const grid=this.querySelector('.kw-album-grid');this.photos.forEach((photo,i)=>{const tile=photo.cloneNode(true);tile.hidden=false;tile.removeAttribute('data-work-photo');tile.removeAttribute('data-shopify-editor-block');tile.addEventListener('click',e=>{e.preventDefault();this.opener=tile;this.index=i;this.paint();this.viewer.showModal();});grid.append(tile);});this.photos.forEach((photo,i)=>photo.addEventListener('click',e=>{e.preventDefault();this.opener=photo;this.index=i;this.paint();this.viewer.showModal();}));this.querySelector('[data-close]').addEventListener('click',()=>this.viewer.close());this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1));this.querySelector('[data-next]').addEventListener('click',()=>this.move(1));this.viewer.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();this.move(-1)}if(e.key==='ArrowRight'){e.preventDefault();this.move(1)}});this.viewer.addEventListener('close',()=>{this.full.removeAttribute('src');this.opener?.focus({preventScroll:true});});let start;this.full.addEventListener('touchstart',e=>{start=e.changedTouches[0].clientX},{passive:true});this.full.addEventListener('touchend',e=>{const distance=e.changedTouches[0].clientX-start;if(Math.abs(distance)>60)this.move(distance<0?1:-1)},{passive:true});}
refresh(){this.photos.forEach((p,i)=>p.hidden=i>=this.limit);this.albumButton.disabled=this.photos.length===0;}
move(delta){this.index=(this.index+delta+this.photos.length)%this.photos.length;this.paint();}
paint(){const p=this.photos[this.index];this.full.src=p.href;this.full.alt=p.dataset.alt;this.querySelector('.kw-caption').textContent=p.dataset.caption;this.querySelector('.kw-counter').textContent=(this.index+1)+' / '+this.photos.length;this.querySelectorAll('[data-prev],[data-next]').forEach(b=>b.hidden=this.photos.length<2);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["killer-zakeke-bridge"] && !Shopify.designMode) return;
  try {
    window.KillerPrint=window.KillerPrint||{};
// ZAKEKE INTEGRATION ENTRY. Official Shopify URL: /apps/zakeke?pid=PRODUCT&id=VARIANT.
// Never use Zakeke's internal mapping ID as the Shopify pid parameter.
window.KillerPrint.launchZakekeCustomizer=function(selection){
 const mount=document.querySelector('kp-zakeke-bridge');
 if(!selection?.productId)return {launched:false,reason:'choose-product'};
 if(selection.zakekeEnabled!==true)return {launched:false,reason:'not-configured'};
 const pid=String(selection.productId).split('/').pop(),vid=String(selection.variantId||'').split('/').pop();
 if(!/^\d+$/.test(pid)||!/^\d+$/.test(vid))return {launched:false,reason:'invalid-variant'};
 const context={version:1,productId:pid,variantId:vid,productName:selection.productName||'',color:selection.color||'',garmentFamily:selection.garmentFamily||'',printMethod:selection.printMethod||null};
 const root=(mount?.dataset.root||'/').replace(/\/$/,'');
 const appPath=window.zakekeUrl||'/apps/zakeke';
 const url=new URL(root+appPath,location.origin);
 if(url.origin!==location.origin)return {launched:false,reason:'invalid-app-route'};
 url.searchParams.set('pid',pid);url.searchParams.set('id',vid);
 // Session state is supplementary. Shopify pid/id in the official URL are authoritative.
 try{sessionStorage.setItem('killer-zakeke-context',JSON.stringify(context));}catch{}
 location.assign(url.href);return {launched:true};
};
// Future AI adapter: no image injection is claimed until the installed Shopify app supports it.
window.KillerPrint.openCustomizerWithArtwork=async function(selection){
 if(typeof window.KillerPrint.zakekeArtworkAdapter!=='function')return {launched:false,reason:'artwork-api-not-configured'};
 return window.KillerPrint.zakekeArtworkAdapter(selection);
};
// Official Zakeke Shopify property hook. Preserve every Zakeke property and earlier hooks.
const priorZakekeProperties=window.zakekePostprocessProperties;
window.zakekePostprocessProperties=async function(props,context){
 const result=priorZakekeProperties?await priorZakekeProperties(props,context):props;
 let selected;try{selected=JSON.parse(sessionStorage.getItem('killer-zakeke-context'));}catch{}
 const url=new URL(location.href);
 // Bind the method to this specific product/variant session, never to an unrelated design.
 if(selected&&url.searchParams.get('pid')===selected.productId&&url.searchParams.get('id')===selected.variantId&&['DTG','DTF'].includes(selected.printMethod))result['Print method']=selected.printMethod;
 return result;
};
if(!window.KillerPrint.zakekeClickBound){window.KillerPrint.zakekeClickBound=true;document.addEventListener('click',e=>{
 const button=e.target.closest('[data-kp-zakeke-launch]');if(!button)return;e.preventDefault();
 const root=button.closest('[data-kp-zakeke-product]');if(!root){window.KillerPrint.launchZakekeCustomizer(null);return;}
 const product=JSON.parse(root.querySelector('[data-kp-zakeke-data]').textContent),select=root.querySelector('[data-kp-zakeke-variant]');
 const variant=product.variants.find(v=>v.id===select.value);if(!variant?.available)return;
 const result=window.KillerPrint.launchZakekeCustomizer({productId:product.id,variantId:variant.id,productName:product.title,color:variant.color,garmentFamily:product.family,zakekeEnabled:product.zakekeEnabled});
 if(!result.launched)root.querySelector('[data-kp-zakeke-status]').hidden=false;
});}
  } catch(e) { console.error(e); }
})();

})();
